import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Subscription from "../../models/subscription/subscription.model";

interface SubscriptionStateType {
    list: Subscription[]
    isLoading: boolean
    error: string
}

const initialState: SubscriptionStateType = {
    list: [],
    isLoading: false,
    error: "",
};

export const SubscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setLoading: (state) => {
            state.isLoading = true;
            state.error = "";
        },
        setSuccess: (state, action: PayloadAction<Subscription[]>) => {
            state.isLoading = false;
            state.list = action.payload;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export default SubscriptionSlice.reducer;
export const { setLoading, setSuccess, setError } = SubscriptionSlice.actions;
